import sharedConstants from "@lib/shared_constants";

import type { AllRouteEndpoints } from "../routeTypes";
import type { ProductAlertTarget, WorkspaceAlertType } from "./types";

export const productAlerts = "/product_alerts";
export const productAlertsId = "/product_alerts/:id";

export const productAlertsIdCacheKeys: AllRouteEndpoints[] = [productAlertsId, productAlerts];

/** `error_code` of the 422 the backend returns when the target already carries its maximum number of alerts. */
export const productAlertTargetLimitReachedErrorCode =
  sharedConstants.PRODUCT_ALERTS.ERROR_CODES.TARGET_ALERT_LIMIT_REACHED;

// `as const` keeps these literal types inside object literals, e.g. the `target` of a workspace PUT body.
export const productAlertTargetAppGroup = "app_group" as const satisfies ProductAlertTarget;

export const workspaceAlertTypeCanvasEntryVolumeChange =
  "CANVAS_ENTRY_VOLUME_CHANGE" as const satisfies WorkspaceAlertType;
export const workspaceAlertTypeCanvasSendVolumeChange =
  "CANVAS_SEND_VOLUME_CHANGE" as const satisfies WorkspaceAlertType;
export const workspaceAlertTypeCanvasArchived = "CANVAS_ARCHIVED" as const satisfies WorkspaceAlertType;

/** The workspace alert types, in display order. */
export const workspaceAlertTypes: WorkspaceAlertType[] = [
  workspaceAlertTypeCanvasEntryVolumeChange,
  workspaceAlertTypeCanvasSendVolumeChange,
  workspaceAlertTypeCanvasArchived,
];
